@if (bannerData) {
  <app-resource-banner [bannerJson]="bannerData" (patientResult)="patientResult($event)">
  </app-resource-banner>
}
<div class="page-title-container d-flex">
  <div class="page-title flex-grow-1 ng-star-inserted">
    <div class="mb-0 ng-star-inserted">
      <div class="d-flex align-items-center">
        <div class="pl-2 pr-2 ng-star-inserted">
          <a class="d-inline-flex" href="javascript:void(0)" (click)="goBack()">
            <img src="assets/images/grid-back.png">
          </a>
        </div>
        <div class="">{{_currentTitle | translate | async}}</div>
      </div>
    </div>
  </div>
</div>
@if (getSurgeryDropDown.datasource && getSurgeryDropDown.question != undefined &&  resourceDef && !hideServeiceRequiest) {
  <label>{{'field.label.surgery_request' | translate |async}}</label>
}
@if (getSurgeryDropDown.datasource && getSurgeryDropDown.question != undefined &&  resourceDef && !hideServeiceRequiest) {
  <kx-multiselect-dropdown
    #multiselectrefer [questions]="getSurgeryDropDown.question" [placeholder]="'Select'"
    [settings]="getSurgeryDropDown.defaultsetting" [controlName]="getSurgeryDropDown"
    [format]="getSurgeryDropDown.question.format" [data]="getSurgeryDropDown.datasource"
    (onSelect)="onSurgeryRequestSelect($event)" (onDeSelect)="onSurgeryRequestDeSelect($event)">
  </kx-multiselect-dropdown>
}

@if (IsDropdownSelected || hideServeiceRequiest) {
  <div>
    <app-common-viewer [resource]="{resource:'ot_checkin_checkout_view_template'}" [bannerJson]="bannerData"></app-common-viewer>
  </div>
}
